import Vue from 'vue'
import Router from 'vue-router'
import FirstLogin from '@/pages/auth/FirstLogin'
import Login from '@/pages/auth/Login'
import PpLogin from '@/pages/auth/PpLogin'
import PpLoginPre from '@/pages/auth/PpLoginPre'
import Home from '@/pages/Home'
import NotFound from '@/pages/NotFound'
import Redirect from '@/pages/Redirect'
import PendingMeeting from '@/pages/PendingMeeting'
import CreateMeeting from '@/pages/Meeting/Create'
import CreateOnlineMeeting from '@/pages/Meeting/CreateOnline'
import ShowMeeting from '@/pages/Meeting/Show'
import EditMeeting from '@/pages/Meeting/Edit'
import CalendarsSettings from '@/pages/Calendar/Settings'
import DeleteAccount from '@/pages/account/Delete'
import Call from '@/pages/Call'
import CalendarsList from '@/pages/Calendar/List'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {auth: true}
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/pending-meetings',
      name: 'pending-meetings',
      component: PendingMeeting,
      meta: {auth: true}
    },
    {
      path: '/login',
      name: 'firstLogin',
      component: FirstLogin,
      meta: {auth: false}
    },
    {
      path: '/login/:userType',
      name: 'login',
      component: Login,
      meta: {auth: false}
    },
    {
      path: '/pplogin',
      name: 'ppLogin_pre',
      component: PpLoginPre
    },
    {
      path: '/pplogin-ex/:token',
      name: 'ppLogin',
      component: PpLogin,
      meta: {auth: false}
    },
    {
      path: '/meetings/create',
      name: 'meetings.create',
      component: CreateMeeting,
      meta: {auth: true}
    },
    {
      path: '/meetings/create/online',
      name: 'meetings.create-online',
      component: CreateOnlineMeeting,
      meta: {auth: true}
    },
    {
      path: '/meetings/:id/show',
      name: 'meetings.show',
      component: ShowMeeting,
      meta: {auth: true}
    },
    {
      path: '/meetings/:id/edit',
      name: 'meetings.edit',
      component: EditMeeting,
      meta: {auth: true}
    },
    {
      path: '/meetings/:id/call',
      name: 'meetings.call',
      component: Call,
      meta: {auth: true}
    },
    {
      path: '/call',
      name: 'shareCall',
      component: Call
    },
    {
      path: '/startup-from/:calledAppName/pmc_cd/:pmcCd',
      name: 'redirect',
      component: Redirect 
    },
    {
      path: '/calendars/settings',
      name: 'calendars.settings',
      component: CalendarsSettings,
      meta: { auth: true }
    },
    {
      path: '/calendars',
      name: 'calendars',
      component: CalendarsList,
      meta: { auth: true }
    },
    {
      path: '/account/delete',
      name: 'account.delete',
      component: DeleteAccount,
      meta: {auth: true}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js